import { useCallback, useEffect, useRef } from 'react';
import { useMutation } from '@apollo/react-hooks';

import { useSSRQuery } from '../useSSRQuery';
import { GET_UICART_QUERY, UPDATE_UICART_MUTATION } from './uiCart.graphql.js';

export const useGetUiCart = () => {
  const {
    data: { uiCart },
  } = useSSRQuery(GET_UICART_QUERY);

  return uiCart;
};

export const useUpdateUiCart = () => {
  const [updateUiCartMutation] = useMutation(UPDATE_UICART_MUTATION);
  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  return useCallback(
    newUiCart => {
      if (isMounted.current && typeof updateUiCartMutation === 'function') {
        updateUiCartMutation({ variables: newUiCart });
      }
    },
    [updateUiCartMutation]
  );
};

export const useUiCart = () => [useGetUiCart(), useUpdateUiCart()];
